const rankings = [
  { rank: 1, title: '星际迷航：新纪元', category: '科幻', score: '9.7', trend: 'up', hot: '↑ 12位' },
  { rank: 2, title: '暗影追踪', category: '动作', score: '9.5', trend: 'up', hot: '↑ 5位' },
  { rank: 3, title: '夏夜之梦', category: '爱情', score: '9.4', trend: 'new', hot: '新上榜' },
  { rank: 4, title: '迷雾森林', category: '悬疑', score: '9.3', trend: 'down', hot: '↓ 2位' },
  { rank: 5, title: '笑傲江湖2026', category: '喜剧', score: '9.2', trend: 'up', hot: '↑ 8位' },
  { rank: 6, title: '深海危机', category: '灾难', score: '9.1', trend: 'stable', hot: '热度稳定' },
];

const trendIcon = (t: string) => {
  if (t === 'up') return { icon: 'ri-arrow-up-line', cls: 'text-accent-500' };
  if (t === 'down') return { icon: 'ri-arrow-down-line', cls: 'text-secondary-400' };
  if (t === 'new') return { icon: 'ri-sparkling-line', cls: 'text-primary-500' };
  return { icon: 'ri-subtract-line', cls: 'text-foreground-300' };
};

const rankBadge = (r: number) => {
  if (r === 1) return 'bg-primary-500 text-background-50';
  if (r === 2) return 'bg-accent-500 text-background-50';
  if (r === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-300 text-foreground-400';
};

export default function RankingSection() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            实时更新的热门电影排行榜，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/50 overflow-hidden">
            {rankings.map((item, idx) => {
              const ti = trendIcon(item.trend);
              return (
                <a
                  key={item.rank}
                  href="#carousel"
                  onClick={(e) => scrollTo(e, '#carousel')}
                  className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 hover:bg-background-200/50 transition-colors cursor-pointer ${
                    idx < rankings.length - 1 ? 'border-b border-background-200/30' : ''
                  }`}
                >
                  <span className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-bold shrink-0 ${rankBadge(item.rank)}`}>
                    {item.rank}
                  </span>

                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-800 truncate">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-400">{item.category}</span>
                  </div>

                  <span className="flex items-center gap-1 text-xs font-medium text-foreground-600 shrink-0">
                    <i className="ri-star-fill text-primary-500 text-xs"></i>
                    {item.score}
                  </span>

                  <span className={`flex items-center gap-0.5 text-xs shrink-0 ${ti.cls}`}>
                    <i className={`${ti.icon} text-xs`}></i>
                    {item.hot}
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}